import http from '@/utils/http';

/**
 * 获取休闲游戏专区日报有日报数据的日期
 * @param data - 参数对象
 * @param data.start_date - 开始日期
 * @param data.end_date - 结束日期
 * @returns 有日报数据的日期
 */
export const fetchCasualDailyReportsDates = (data?: {
  start_date: string;
  end_date: string;
}): IBaseResponse<string[]> => {
  return http({
    url: '/api/v1/intelligence_pc/report/casual/daily/date',
    method: 'post',
    data,
    rawData: true,
  }) as any;
};

/**
 * 获取休闲游戏专区日报详情
 * @param data - 参数对象
 * @param data.report_date - 日报日期
 */
export const fetchCasualDailyReportDetails = (data: {
  report_date: string;
}): IBaseResponse<{ data: ICasualDailyReportData | null; exist: boolean }> => {
  return http({
    url: '/api/v1/intelligence_pc/report/casual/daily/get_data',
    method: 'post',
    data,
    rawData: true,
  }) as any;
};
